export const SUPPORT_LINK = 'https://support.cian.ru/ru/knowledge_base/art/94/cat/179/';
export const PROFILE_URL = 'https://my.cian.ru/profile';
export const CONTENT_RATING_PATH = '/reyting-rieltorov/?location=0&agent_id=';
